import { useTranslate } from "@similarweb/i18n-provider";

import "dayjs/locale/fr";
import "dayjs/locale/ja";
import "dayjs/locale/zh";
import "dayjs/locale/de";
import "dayjs/locale/ru";
import "dayjs/locale/es";
import "dayjs/locale/it";
import "dayjs/locale/pt";
import "dayjs/locale/tr";
import "dayjs/locale/ko";

import { createMonthlyTimeString, createWeeklyTimeString } from "app/common/benchmark/dateHelpers";

import { BenchmarkGranularity } from "../../types/common";

export const useLocalizedDate = (granularity: BenchmarkGranularity, duration?: string, isShortForm = false) => {
    const { getLocale } = useTranslate();
    const language = getLocale()?.slice(0, 2);

    return granularity === BenchmarkGranularity.WEEKLY
        ? createWeeklyTimeString(language, duration, isShortForm)
        : createMonthlyTimeString(language, duration, isShortForm);
};
